"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copyright = Copyright;
var jsx_runtime_1 = require("react/jsx-runtime");
var text_component_1 = require("../ui/text-component");
function Copyright() {
    // get current date year
    var currentYear = new Date().getFullYear();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-center gap-3", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "primary-navy", label: "\u00A9 ".concat(currentYear) }), (0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", children: "\u00B7" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "primary-navy", label: "CannaLedger (PTY) Ltd" })] }));
}
